// extracted by mini-css-extract-plugin
module.exports = {"newsFeed":"rkq_t4","opened":"gt4TYT","hide":"_4iPdjt","closer":"P44gKd","opener":"CfyRKA","inverted":"_3BTAh_"};